export const COUNTRY_KEY = "COUNTRY";

export const COUNTRY_CACHE_KEYS = {
  LIST: [COUNTRY_KEY, "LIST"] as const,
  DETAIL: (id: string) => [COUNTRY_KEY, id] as const,
};
